import { useNavigate } from "react-router-dom";
import { Card } from "../../../components/card/card.jsx";

import TableBody from "../../../components/table/TableBody.jsx";

function Symbols() {
	const navigate = useNavigate();

	const handleAddAccount = (send) => {
		navigate("/symbolsDetails", { state: send });
	};

	return (
		<div>
			<div className="d-flex align-items-center mb-3">
				<div>
					<h1 className="page-header mb-0">Símbolos</h1>
				</div>
				<div className="ms-auto">
					<button onClick={() => handleAddAccount({ type: "add" })} className="btn btn-outline-theme">
						<i className="fa fa-plus-circle fa-fw me-1"></i> Agregar Símbolo
					</button>
				</div>
			</div>

			<Card>
				<div className="tab-content p-4">
					<div className="tab-pane fade show active" id="allTab">
						<TableBody table={"symbols"} />
					</div>
				</div>
			</Card>
		</div>
	);
}

export default Symbols;
